/**
 * TanStack Query wrapper for `testSuitesAPI.getById(suiteId)`.
 *
 * Used by run-detail to surface the suite name on replay runs. Cached
 * indefinitely — suite names rarely change, and a stale read just
 * means a header label lags behind a rename until the next refresh.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { testSuitesAPI } from '@/lib/api'
import type { TestSuite } from '@/types'

export function useTestSuite(
  suiteId: string | undefined | null,
): UseQueryResult<TestSuite | null> {
  return useQuery({
    queryKey: ['test-suite', suiteId],
    queryFn: () => {
      if (!suiteId) throw new Error('useTestSuite: suiteId required')
      return testSuitesAPI.getById(suiteId)
    },
    enabled: !!suiteId,
    staleTime: Infinity,
  })
}
